import React from 'react';
import { Tabs } from 'antd';
import ProductsTab from 'screens/Applications&WorkOrders/Components/DetailsTabs/components/ProductsTab';
import AppliedAreaTab from 'screens/Applications&WorkOrders/Components/DetailsTabs/components/AppliedAreaTab';
import DetailsTab from 'screens/Applications&WorkOrders/Components/DetailsTabs/components/DetailsTab';
import WeatherTab from 'screens/Applications&WorkOrders/Components/DetailsTabs/components/WeatherTab';
import NotesTab from 'screens/Applications&WorkOrders/Components/DetailsTabs/components/NotesTab';
import {
  FullProduct,
  TankInformation
} from 'screens/Applications&WorkOrders/Applications/Hooks/useApplication';
import { OperationPropertyVO } from 'screens/Applications&WorkOrders/Components/hooks/useOperationProperties';
import { OperationType } from 'screens/Applications&WorkOrders/RouteAdmin';
import useActiveTab from 'screens/Applications&WorkOrders/Components/hooks/useActiveTab';
import { OperationDetails } from '../types';
import {
  OPERATION_DETAILS_TABS_WRAPPER_CLASS,
  TAB_KEYS,
  TAB_LABELS,
  TAB_TYPE
} from './constants';
import './index.css';

export interface DetailsTabsProps {
  type?: OperationType;
  details: OperationDetails;
  products: FullProduct[];
  propertiesData: OperationPropertyVO[];
  tankInformation?: TankInformation;
  isLoadingProducts?: boolean;
  isLoadingProperties?: boolean;
  showWeatherTab?: boolean;
}

const DetailsTabs = ({
  type = OperationType.APPLICATION,
  details,
  products,
  propertiesData,
  tankInformation,
  isLoadingProducts = false,
  isLoadingProperties = false,
  showWeatherTab = false
}: DetailsTabsProps) => {
  const storageKey =
    type === OperationType.APPLICATION
      ? 'application-details'
      : 'work-order-details';
  const { activeTab, setActiveTab } = useActiveTab(storageKey);

  const weatherInfo = {
    weather: (details as any)?.weather || {},
    startDate: details.startDate,
    endDate: details.endDate
  };

  const notesInfo = {
    notes: details.notes || ''
  };

  const items = [
    {
      key: TAB_KEYS.PRODUCTS,
      label: TAB_LABELS.PRODUCTS,
      children: (
        <ProductsTab
          products={products}
          tankInformation={tankInformation}
          isLoading={isLoadingProducts}
        />
      )
    },
    {
      key: TAB_KEYS.APPLIED_AREA,
      label: TAB_LABELS.APPLIED_AREA,
      children: (
        <AppliedAreaTab
          propertiesData={propertiesData}
          cropSeasonIds={details.cropSeasonIds || []}
          isLoading={isLoadingProperties}
        />
      )
    },
    {
      key: TAB_KEYS.DETAILS,
      label: TAB_LABELS.DETAILS,
      children: <DetailsTab applicationDetails={details as any} type={type} />
    },
    ...(showWeatherTab
      ? [
          {
            key: TAB_KEYS.WEATHER,
            label: TAB_LABELS.WEATHER,
            children: <WeatherTab weatherInfo={weatherInfo} />
          }
        ]
      : []),
    {
      key: TAB_KEYS.NOTES,
      label: TAB_LABELS.NOTES,
      children: <NotesTab notesInfo={notesInfo} type={type} />
    }
  ];

  return (
    <div
      data-testid="operation-details-tabs"
      className={`${OPERATION_DETAILS_TABS_WRAPPER_CLASS} mt-4`}
    >
      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        items={items}
        type={TAB_TYPE}
        className="leading-5"
      />
    </div>
  );
};

export default DetailsTabs;
